import { SORT_ORDER } from "@/utils/constant";
import { BreadcrumbData } from "@/utils/types/recipes";

// Parse Html
export const decodeHtml = (html: any) => {
  const doc = new DOMParser().parseFromString(html, "text/html");
  return doc.documentElement.textContent;
};

// Convert to GM
export const convertToGm = (met: string): number => {
  if (!met) return 0; // Handle empty values
  const value = parseFloat(met); // Extract numeric part
  if (met.includes("mL")) return value * 1; // Convert mL to gm (adjust ratio if needed)
  if (met.includes("gm")) return value; // gm is already in gm
  return 0;
};

// Change algolia values to slug
export const toSlug = (str: string) => {
  const encodeSlug = str
    .toLowerCase()
    .replace(/ /g, "-")
    .replace(/[^\w-]+/g, "");

  return encodeURIComponent(encodeSlug);
};

// Print the Recipes detail
export const handlePrint = () => {
  window.print();
};

export const breadcrumbListRecipeDetails = (
  slug: string,
  title: string
): BreadcrumbData[] => [
  { text: "Home", href: "/" },
  { text: "Recipes", href: "/recipes" },
  { text: title ?? slug, href: "" },
];

export const getSortedIngredient = (ingredient: any) => {
  const result: any = ingredient
    .map((item: any) => ({
      ...item,
      quantity: {
        ...item.quantity,
        MetInGm: convertToGm(item.quantity.Met),
      },
    }))
    .reduce((maxItem: any, item: any) => {
      return item.quantity.MetInGm > maxItem.quantity.MetInGm ? item : maxItem;
    });

  return result.ingredient;
};

const fractionMap: Record<string, string> = {
  "1/2": "½",
  "1/3": "⅓",
  "2/3": "⅔",
  "1/4": "¼",
  "3/4": "¾",
  "1/5": "⅕",
  "2/5": "⅖",
  "3/5": "⅗",
  "4/5": "⅘",
  "1/6": "⅙",
  "5/6": "⅚",
  "1/8": "⅛",
  "3/8": "⅜",
  "5/8": "⅝",
  "7/8": "⅞",
};

export const formatQuantityValue = (value: string) => {
  return value.replace(/(\d)\/(\d)/, (_, numerator, denominator) => {
    const fraction = `${numerator}/${denominator}`;
    return fractionMap[fraction] || fraction;
  });
};

export const aemSortOrder = (aemFilterData: any) => {
  const sortOrder = [];

  if (aemFilterData?.tags) {
    sortOrder.push({
      attribute: SORT_ORDER[0].attribute,
      name: aemFilterData.tags,
    });
  }

  if (aemFilterData?.skillLevel) {
    sortOrder.push({
      attribute: SORT_ORDER[1].attribute,
      name: aemFilterData.skillLevel,
    });
  }

  if (aemFilterData?.totalTime) {
    sortOrder.push({
      attribute: SORT_ORDER[2].attribute,
      name: aemFilterData.totalTime,
    });
  }

  return sortOrder;
};